import { beamPageLoad } from 'js/services/tagularEvent'
import { generateNewPurchaseID } from 'js/bankrate-tracking/meta'
import 'intersection-observer'
import { queryParam } from '../apps/utility/queryParams'

let productsUuid = {}
let uuidObject = {
  cd: generateUuid(),
  savings: generateUuid(),
  checking: generateUuid(),
  mma: generateUuid()
}

window.dataLayer = window.dataLayer || []

function addProductListViewedDesktop() {
  let activeTab = this.getAttribute('data-productname')
  sendProductListViewedEvent(activeTab)
}

function addProductListViewedMobile(product) {
  sendProductListViewedEvent(product)
}

function addProductViewed() {
  const rateProducts = document.querySelectorAll('.rate-product')

  let productObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        if (!entry.target.classList.contains('product-viewed')) {
          entry.target.classList.add('product-viewed')
          sendProductViewedEvent(entry.target)
        }
      }
    })
  })

  rateProducts.forEach(product => {
    productObserver.observe(product)
  })
}

function generateProductListViewedEvent(isDesktop) {
  let activeTab = '';

  if (isDesktop) {
    let clickList =  Array.from(document.querySelectorAll('.product-click'))
    clickList.forEach(function (click) {
      click.addEventListener('click', addProductListViewedDesktop)
      if (click.classList.contains('--is-active')) {
        activeTab = click.getAttribute('data-productname')
      }
    })
  } else {
    let dropDown = Array.from(document.querySelectorAll('.product-dropdown'))
    activeTab = dropDown[0].getAttribute('data-productname')
  }

  sendProductListViewedEvent(activeTab)
}

function getProductObject(data, count) {
  let key = data.getAttribute('data-name') + count;
  let productId;

  if (data.dataset.productId) { // if element has product ID
    productId = data.dataset.productId
  } else if (data.parentElement.parentElement.dataset.productId){ // if parent of parent has peoduct ID
    productId = data.parentElement.parentElement.dataset.productId
  } else if (!productsUuid.hasOwnProperty(key)) { // generate product ID
    productId = productsUuid[key] = generateUuid()
  }

  const obj = {
    productId:  productId,
    category: data.getAttribute('data-category'),
    brand: data.getAttribute('data-brand'),
    price: parseFloat(data.getAttribute('data-price')),
    position: parseInt(count, 10),
    location: data.getAttribute('data-location') || 'GRID',
    variant: data.getAttribute('data-apy'),
  }


  return obj;
}

function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = (Math.random() * 16) | 0
    let v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

function sendProductClickedEvent() {
  // Tagular Event
  beamPageLoad('ProductClicked', {
    product: getProductObject(this, this.getAttribute('data-count')),
    listId: `${uuidObject[this.getAttribute('data-producttype')]}(0)`,
    correlationId: `${window.purchaseId}`
  }, 'ecommerce', 'v1')

  // Assemble Object for GTM Click Event
  let gtmClickPayload = {
    purchaseID: window.purchaseId,
    rateAdvertiser: this.getAttribute('data-brand').toLowerCase(),
    purchaseType: this.getAttribute('data-producttype').toLowerCase(),
    rateTerm: this.getAttribute('data-term') ? this.getAttribute('data-term') : null,
    rateAPR: this.getAttribute('data-apy') ? this.getAttribute('data-apy') : null,
    ecommerce: {
      click: {
        actionField: {
          action: 'click',
          list: 'review product'
        },
        products: [{
          brand: this.getAttribute('data-brand').toLowerCase(),
          category: this.getAttribute('data-producttype').toLowerCase(),
          dimension83: 'default',
          dimension84: 'paid',
          dimension89:this.getAttribute('data-price') ? '$' + this.getAttribute('data-price') : null,
          dimension129: this.getAttribute('data-count'),
          dimension130: this.getAttribute('data-apy') ? this.getAttribute('data-apy') + '%' : null,
          list: 'review product',
          name: 'deposits',
          position: this.getAttribute('data-count'),
          quantity: 1,
          variant: this.getAttribute('data-term') ? this.getAttribute('data-term') : null
        }]
      },
    }
  }


  // Push GTM Click Event to Data Layer
  window.dataLayer.push({ event: 'e_RTClick', ...gtmClickPayload })

  // Send EP Link Last
  sendEpLink(this)
}

function sendElementClickedEvent() {
  beamPageLoad('ElementClicked', {
    'webElement': {
      'location': this.getAttribute('data-location'),
      'position': this.getAttribute('data-count'),
      'elementType': this.getAttribute('data-element-type'),
      'text': this.getAttribute('data-tracking-text'),
      'name': this.getAttribute('data-element-name')
    },
    'actionOutcome': this.getAttribute('data-action-outcome'),
    'correlationId': `${window.purchaseId}`
  }, 'usertracking', 'v3')
}

function sendTabElementClickedEvent() {
  beamPageLoad('ElementClicked', {
    'webElement': {
      'location': this.getAttribute('data-location'),
      'position': this.getAttribute('data-count'),
      'elementType': 'Tab',
      'text': this.getAttribute('data-product')
    },
    'actionOutcome': `VIEW${this.getAttribute('data-product').toUpperCase().replace(' ', '')}`
  }, 'usertracking', 'v3')
}

function sendProductListViewedEvent(activeTab) {
  let rates =  Array.from(document.querySelectorAll('.rate-product-list'))
  let ratesArray = []
  let gtmRatesArray = []
  let position = 1

  // Assemble Object for GTM Load Event
  let gtmLoadPayload = {
    rtCategory: activeTab,
    rateLocation: 'los angeles, ca', // hardcoded location because we don't currently use geolocation for bank reviews
    ecommerce: {
      impressions: gtmRatesArray
    }
  }

  rates.forEach(function(rate) {
    if (!rate.classList.contains('element-viewed') && activeTab === rate.getAttribute('data-name')) {
      rate.classList.add('element-viewed')
      let rateObject = getProductObject(rate, position)
      // track data for Tagular
      ratesArray.push(rateObject)

      // Assemble impression array for GTM
      gtmRatesArray.push({
        brand: rate.getAttribute('data-brand').toLowerCase(),
        category: rate.getAttribute('data-producttype').toLowerCase(),
        dimension83: 'default',
        dimension84: rate.getAttribute('data-productlisting'),
        dimension89: rate.getAttribute('data-price') ? '$' + rate.getAttribute('data-price') : null,
        dimension129: rate.getAttribute('data-count'),
        dimension130: rate.getAttribute('data-apy') ? rate.getAttribute('data-apy') + '%' : null,
        list: 'review product',
        name: 'deposits',
        position: rate.getAttribute('data-count'),
        quantity: 1,
        variant: rate.getAttribute('data-term') ? rate.getAttribute('data-term') : null
      })
      position++
    }
  })

  if (ratesArray.length && activeTab) {
    beamPageLoad('ProductListViewed', {
      product: ratesArray,
      listId: `${uuidObject[activeTab]}(0)`
    }, 'ecommerce', 'v1')

    // Push GTM Load Event to Data Layer
    window.dataLayer.push({ event: 'e_RTLoad', ...gtmLoadPayload })
  }
}

function sendProductViewedEvent(product) {
  beamPageLoad('ProductViewed', {
    product: getProductObject(product, product.getAttribute('data-count')),
    listId: `${uuidObject[product.getAttribute('data-producttype')]}(0)`
  }, 'ecommerce', 'v1')
}

function sendEpLink(element) {
  event.preventDefault()
  let epUrl = element.getAttribute('data-ep')
  let position = element.getAttribute('data-count')
  let clickType = element.getAttribute('data-clicktype')
  let ttcid = queryParam('ttcid')
  let pid = queryParam('pid')

  let today = new Date()
  let year = today.getFullYear()
  let month = today.getMonth() + 1
  let date = today.getDate()
  let hour = today.getHours()
  let minute = today.getMinutes()
  let second = today.getSeconds()
  let millisecond = today.getMilliseconds()
  let clickDate = month + '/' + date + '/' + year + ' ' + hour + ':' + minute + ':' + second + '.' + millisecond

  let refUrl = window.location.href
  let purchaseId = window.purchaseId

  let endPosition = `${pid}&click_date=${clickDate}&ref_url=${refUrl}&pur_id=${purchaseId}`
  endPosition = ttcid ? endPosition.concat(`&ttcid=${ttcid}`) : endPosition

  if (epUrl.indexOf('://dep-click-service.') > -1) {
    epUrl = `${epUrl}?`
  }

  // construct URL
  let url = `${epUrl}&c=${position},${clickType},,,,${endPosition}`

  // redirect URL
  let win = window.open(url, '_blank')
  win.focus()


  // generate new purchase ID
  generateNewPurchaseID()
}

export {
  generateProductListViewedEvent,
  addProductListViewedDesktop,
  addProductListViewedMobile,
  sendProductClickedEvent,
  sendElementClickedEvent,
  sendTabElementClickedEvent,
  addProductViewed,
  getProductObject,
  generateUuid,
  sendEpLink
}
